import React from "react";
/**
 * Render the table row containing the weekday names.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
export function Weekdays(props) {
    return (React.createElement("thead", { "aria-hidden": true },
        React.createElement("tr", { ...props })));
}
